
import { TextField, Switch, Button } from '@mui/material';
import React, { Component } from 'react';

class AutoComplete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            useGPS: false,
            latitude: props.lat || null, 
            longitude: props.lng || null, 
        };
        this.clearSearchBox = this.clearSearchBox.bind(this);
    }

    componentDidMount() {
        const { map, mapApi } = this.props;
        const options = {
            types: ['address'],
        };
        this.autoComplete = new mapApi.places.Autocomplete(
            this.searchInput,
            options,
        );
        this.autoComplete.addListener('place_changed', this.onPlaceChanged);
        this.autoComplete.bindTo('bounds', map);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.lat !== this.props.lat || prevProps.lng !== this.props.lng) {
            this.setState({ 
                latitude: this.props.lat,
                longitude: this.props.lng
            });
        }
    }

    componentWillUnmount() {
        const { mapApi } = this.props;
        mapApi.event.clearInstanceListeners(this.searchInput);
    }

    onPlaceChanged = () => {
        const { map, addplace } = this.props;
        const place = this.autoComplete.getPlace();

        if (!place.geometry) return;
        if (place.geometry.viewport) {
            map.fitBounds(place.geometry.viewport);
        } else {
            map.setCenter(place.geometry.location);
            map.setZoom(17);
        }

        addplace(place);
        this.searchInput.blur();
    };

    clearSearchBox() {
        this.searchInput.value = '';
    }

    toggleUseGPS = () => {
        this.setState(prevState => {
            const newUseGPS = !prevState.useGPS;
            this.props.setIsGpsEnabled(newUseGPS);
            return { useGPS: newUseGPS };
        });
    };
    

    handleGetGPS = () => {
        const options = {
            maximumAge: 0,
            timeout: 10000,
            enableHighAccuracy: true,
        };

        navigator.geolocation.getCurrentPosition(
            position => {
                const { latitude, longitude } = position.coords;

                this.setState({
                    latitude: latitude,
                    longitude: longitude,
                });

                if (this.props.fetchAddressOnPointerChange) {
                    this.props.fetchAddressOnPointerChange(latitude, longitude);
                }
            },
            error => {
                let errorMessage;
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        errorMessage = "User denied the request for Geolocation.";
                        break;
                    case error.POSITION_UNAVAILABLE:
                        errorMessage = "Location information is unavailable.";
                        break;
                    case error.TIMEOUT:
                        errorMessage = "The request to get user location timed out.";
                        break;
                    case error.UNKNOWN_ERROR:
                    default:
                        errorMessage = "An unknown error occurred.";
                        break;
                }

                window.alert(errorMessage);
            },
            options
        );
    };

    handleCoordinateChange = (e) => {
        const { value } = e.target;
        const [lat, lng] = value.split(',').map(coord => parseFloat(coord.trim()));

        if (isNaN(lat) || isNaN(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180) {
            window.alert('Please enter valid coordinates.');
            return;
        }

        this.setState({ latitude: lat, longitude: lng });

        if (this.props.fetchAddressOnPointerChange) {
            this.props.fetchAddressOnPointerChange(lat, lng);
        }
    };

    render() {
        return (
            <>
                {/* <div style={{ marginBottom: '15px' }}>
                    <label>
                        Use GPS
                        <Switch checked={this.state.useGPS} onChange={this.toggleUseGPS} />
                    </label>
                    {this.state.useGPS && (
                        <Button onClick={this.handleGetGPS}>Get Current GPS Coordinates</Button>
                    )}
                </div> */}
                <TextField
                    className={`inputPadding`}  
                    fullWidth
                    label={"Latitude, Longitude" }
                    value={`${this.state.latitude}, ${this.state.longitude}`}
                    onChange={this.handleCoordinateChange}
                    inputRef={(ref) => {
                        this.searchInput = ref;
                    }} 
                    sx={{ marginBottom: "15px !important" }}
                    placeholder=""
                    id="outlined-search" 
                    type="search" 
                    variant="outlined"
                />
                 <TextField
                    className={`inputPadding`}  
                    fullWidth
                    label={ "Address"}
                    value={ this.props.updatedValue || ''}
                    onChange={(e) => this.props.onChangeHandler(e, 'addressLine')}
                    inputRef={(ref) => {
                        this.searchInput = ref;
                    }} 
                    sx={{ marginBottom: "15px !important" }}
                    placeholder=""
                    id="outlined-search" 
                    type="search" 
                    variant="outlined"
                />
            </>
        );
    }
}

export default AutoComplete;
